import { useRef } from 'react'

import { usePageScrollPercentage } from '~/bootcamp/hooks/usePageScrollPercentage'
import useProgressBarScrolling from '~/shared/hooks/useProgressBarScrolling'

const PageProgressBar = (): React.ReactElement => {
  const completion = usePageScrollPercentage()
  const ref = useRef<HTMLDivElement>(null)
  useProgressBarScrolling(ref)
  return (
    <div className="duration-500 sticky z-50 top-0 bg-black-breadcrumb h-1" data-testid="page-progress-bar" ref={ref}>
      <span
        className="absolute bottom-0 w-full transition-transform duration-150 h-1 bg-orange"
        style={{
          transform: `translateX(${completion - 100}%)`,
        }}
      />
    </div>
  )
}

export default PageProgressBar
